<template>
  <div class="spoiler-wrapper overflow-hidden relative" :class="{ 'blur-img': !isVisible }">
    <div class="z-1 absolute u-center inset-0 w-full h-full cursor-pointer" @click="handleSpoiler">
      <OButton v-if="!isVisible" pure class="text-xl font-bold min-w-16 px-16 p-4 bg-gray-900 bg-opacity-70 text-white">
        {{ $t('news-page.click-to-see') }}
      </OButton>
    </div>
    <div class="-z-1"><slot /></div>
  </div>
</template>

<script>
import { defineComponent, ref } from '@nuxtjs/composition-api';
import { OButton } from '~/modules/common/components/ui';

export default defineComponent({
  components: { OButton },
  setup() {
    const isVisible = ref(false);
    const handleSpoiler = () => {
      isVisible.value = !isVisible.value;
    };
    return { isVisible, handleSpoiler };
  },
});
</script>

<style>
.blur-img img {
  filter: blur(25px);
}
</style>
